var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"087a3543a4d392c1d74f07f2c3c9a9f856251241"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["planet-donations@plant-for-the-planet"]={id:"087a3543a4d392c1d74f07f2c3c9a9f856251241"};
      